import includes from 'lodash/includes';

import { ResidentialBusinessAddressDescriptions } from '@jerry-serverless/enums/address_description';

import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';
import type { Step } from '../types/step';

// Ask for another address
export const AnotherAddressStep: Step = {
  id: 'anotheraddress',
  pathname: '/anotheraddress',
  canShow: (appData: AppData) => {
    return (
      !!appData.needAnotherAddress &&
      !includes(ResidentialBusinessAddressDescriptions, appData.signupParams?.addressDescription)
    );
  },

  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    return !appData.signupParams?.addressBusiness;
  },
  category: () => StepCategory.Account,
};
